import { render } from "./GeneralInformationBar.vue?vue&type=template&id=33326278"
import script from "./GeneralInformationBar.vue?vue&type=script&lang=js"
export * from "./GeneralInformationBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__